var React = require('react');

function RoundedCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.2069 5.68176L7.18186 13.7068C6.99434 13.8941 6.74009 13.9994 6.47499 13.9994C6.20988 13.9994 5.95563 13.8941 5.76811 13.7068L1.29186 9.20675C1.10466 9.01926 0.999512 8.76514 0.999512 8.50019C0.999512 8.23524 1.10466 7.98112 1.29186 7.79363L2.54186 6.54363C2.72928 6.357 2.98299 6.25222 3.24749 6.25222C3.51198 6.25222 3.7657 6.357 3.95311 6.54363L6.49999 9.01363L12.5475 3.04051C12.7349 2.85368 12.9888 2.74878 13.2534 2.74878C13.5181 2.74878 13.7719 2.85368 13.9594 3.04051L15.2062 4.26176C15.3 4.35468 15.3744 4.46525 15.4253 4.58708C15.4761 4.70892 15.5023 4.83961 15.5023 4.97163C15.5024 5.10364 15.4763 5.23435 15.4256 5.35624C15.3749 5.47812 15.3005 5.58875 15.2069 5.68176Z","fill":"white"}));
}

RoundedCheck.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = RoundedCheck;

RoundedCheck.default = RoundedCheck;
